import { useCallback } from 'react';
//import type { UseQueryOptions } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useQueryClient } from '@tanstack/react-query';
import type { GetCallTranscript } from '@trinity/chat/api/interfaces/calls';
//import * as api from '@/api/calls';
import { type UseQueryOptions, useQueryWrapper } from '@trinity/chat-components/hooks/useQueryWrapper';

type Data = GetCallTranscript.Response;
type QueryKey = readonly [string, ICallId];

const buildQueryKey = (data: ICallId): QueryKey => {
  return ['call-transcript', data];
};

export function useCallTranscript(
  data: ICallId,
  options?: Omit<UseQueryOptions<Data, AxiosResponse, Data, QueryKey>, 'queryKey' | 'queryFn'>,
) {

  return useQueryWrapper({
    queryKey: buildQueryKey(data), queryFn: ({ queryKey }) => {

      /*
      return api.getCallTranscript({
        callId,
      });
      */
      return Promise.reject('Not implemented');
    }, ...options,
  });
}

export function useInvalidateCallTranscriptQuery() {
  const queryClient = useQueryClient();

  return useCallback((data: ICallId) => {
    const queryKey = buildQueryKey(data);

    return queryClient.invalidateQueries({ queryKey });
  }, [queryClient]);
}